$(document).ready(function() {
  if (!$(".loop-fader").length)
    return


  $(".loop-fader").each(function () {
    const $wrapper = $(this)
    const $arrowLeft = $($wrapper.find('.loop-left')[0])
    const $arrowRight = $($wrapper.find('.loop-right')[0])

    const fadeTimer = window.fadeTimer || 10000
    const items = $wrapper.children('div').fadeOut(0)
    const numberOfItems = items.length
    let currentItemNumber = 0
    fade()
    if (numberOfItems < 2) {
      $arrowLeft.remove()
      $arrowRight.remove()
      return
    }
    let fadeLoop = setInterval(fade, fadeTimer)

    $(window).resize(function() {
      const currentItem = $wrapper.children(`div:nth-child(${currentItemNumber})`)
      $wrapper.animate({ height: currentItem.height() }, 200)
    })

    $arrowLeft.click(function() {
      fade(true)
      clearInterval(fadeLoop)
      fadeLoop = setInterval(fade, fadeTimer)
    })
    $arrowRight.click(function() {
      fade()
      clearInterval(fadeLoop)
      fadeLoop = setInterval(fade, fadeTimer)
    })

    function fade(previous) {
      const lastItem = $wrapper.children(`div:nth-child(${currentItemNumber})`).fadeOut(1000)

      if (previous) {
        if((currentItemNumber - 1) === 0)
          currentItemNumber = numberOfItems
        else
          currentItemNumber--
      }
      else
        currentItemNumber = currentItemNumber % numberOfItems + 1

      const currentItem = $wrapper.children(`div:nth-child(${currentItemNumber})`).fadeIn(1000)

      if(lastItem.height() > currentItem.height())
        $wrapper.animate({ height: currentItem.height() }, 1500)
      else
        $wrapper.animate({ height: currentItem.height() }, 500)
    }






  })
})



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/loop-fader.js